import { render } from "./KuJiaLe.vue?vue&type=template&id=78ee4707"
import script from "./KuJiaLe.vue?vue&type=script&lang=js"
export * from "./KuJiaLe.vue?vue&type=script&lang=js"

import exportComponent from "E:\\webprogram\\KfKujialeCrm\\kf-kujiale-crm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/KuJiaLe.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78ee4707"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78ee4707', __exports__)) {
    api.reload('78ee4707', __exports__)
  }
  
  module.hot.accept("./KuJiaLe.vue?vue&type=template&id=78ee4707", () => {
    api.rerender('78ee4707', render)
  })

}


export default __exports__